<template>
  <div>
    <div>
      <el-row :gutter="24"
              class="therow">
        <!-- 顶部标题 -->
        <div class="top_box">
          <dv-decoration-10 class="top_decoration10" />
          <div class="title-box">
            <dv-decoration-8 class="top_decoration8" />
            <div class="title">
              <span class="title-text">大数据可视化</span>
              <dv-decoration-6 :reverse="true"
                               class="title-bototm top_decoration6" />
            </div>
            <dv-decoration-8 :reverse="true"
                             class="top_decoration8" />
          </div>
          <dv-decoration-10 class="top_decoration10 top_decoration10_reverse" />
          <TimeBox class="time-box">
            <h3>{{ nowTime }}</h3>
          </TimeBox>
        </div>
        <!-- 左侧 -->
        <el-col :key="intervalId"
                :span="7"
                class="left-style">

          <!-- 左上  月度总销量分物资-->
          <el-row>
            <el-col :span="24">
              <dv-border-box-11 title="月度总销量分物资"
                                class="left-style-top"
                                backgroundColor="#101A34">
                <transverse-column v-if="varData.length"
                                   :varData="this.varData"
                                   :weightData="this.weightData"></transverse-column>
              </dv-border-box-11>
            </el-col>
          </el-row>

          <!-- 左下 月度总销量分物资 -->
          <el-row>
            <el-col :span="24">
              <!-- 日销量分物资 -->
              <dv-border-box-13 class="left-style-center"
                                backgroundColor="#101A34">
                <ring-chart v-if="theData.length"
                            :theData="this.theData"></ring-chart>
              </dv-border-box-13>

            </el-col>
          </el-row>
        </el-col>
        <!-- 中间 -->
        <el-col :span="10"
                class="center-style">
          <!-- 中上 -->
          <el-row :key="intervalId2"
                  :gutter="24">
            <el-col :span="24">
              <dv-border-box-10 class="center-style-top"
                                backgroundColor="#101A34">
                <div class="center-top-content">
                  <div class="total">
                    <!-- 总计销售额 -->
                    <div class="total-top">
                      现金
                      <span class="total-number">
                        {{fromTotal.money.cashShipMoney }}
                        <span style="font-size: 15px;color: #fff;"> 元 </span>
                      </span>
                      &nbsp;&nbsp;
                      承兑
                      <span class="total-number">
                        {{fromTotal.money.acceptRemainMoney }}

                        <span style="font-size: 15px;color: #fff;"> 元</span>
                      </span>
                    </div>
                    <div class="total-bottom">
                      <dv-border-box-3>
                        <el-row>
                          <div style="margin-top: 20px;"></div>
                          <el-col :span="8">
                            <div class="grid-content">年发运车数</div>
                          </el-col>
                          <el-col :span="8">
                            <div class="grid-content">年发运量</div>
                          </el-col>
                          <el-col :span="8">
                            <div class="grid-content">年销售额</div>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="8">
                            <div class="grid-content"
                                 style="color: #F9E67D; font-size: 28px;"> {{fromTotal.yeardata.actualNumber }}</div>
                          </el-col>
                          <el-col :span="8">
                            <div class="grid-content"
                                 style="color: #F9E67D;font-size: 28px;"> {{fromTotal.yeardata.netWeight }}</div>
                          </el-col>
                          <el-col :span="8">
                            <div class="grid-content"
                                 style="color: #F9E67D;font-size: 28px;"> {{fromTotal.yeardata.money }}</div>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="8">
                            <div class="grid-content">日发运车数<span style="color: #F9E67D;"> {{fromTotal.daydata.actualNumber  }}</span></div>
                          </el-col>
                          <el-col :span="8">
                            <div class="grid-content">日发运量<span style="color: #F9E67D;"> {{fromTotal.daydata.netWeight  }}</span></div>
                          </el-col>
                          <el-col :span=" 8">
                            <div class="grid-content">日销售额<span style="color: #F9E67D;"> {{fromTotal.daydata.money  }}</span></div>
                          </el-col>
                        </el-row>
                      </dv-border-box-3>
                    </div>
                  </div>

                  <div class="collect">
                    <dv-border-box-11 title="实时出厂车辆信息"
                                      class="center-style-collect"
                                      backgroundColor="#101A34">
                      <shipments-comparison :shipmentsLsit="shipmentsLsit"></shipments-comparison>
                    </dv-border-box-11>
                  </div>
                </div>
              </dv-border-box-10>
            </el-col>
          </el-row>
          <!-- 中下 -->
          <el-row :key="intervalId">
            <el-col :span="24">
              <dv-border-box-11 title="周销量"
                                class="center-style-bottom"
                                backgroundColor="#101A34">
                <LineChart v-if="weekWeight.length"
                           :weekTime="this.weekTime"
                           :weekWeight="this.weekWeight"></LineChart>
              </dv-border-box-11>
            </el-col>
          </el-row>

        </el-col>
        <!-- 右侧 -->
        <el-col :key="intervalId"
                :span="7"
                class="right-style">
          <!-- 右上  -->
          <el-row>
            <el-col :span="24">
              <dv-border-box-11 title="月度销量"
                                class="right-style-top"
                                backgroundColor="#101A34">
                <month-sales-column v-if="monthlyWeight.length"
                                    :monthlyTime="this.monthlyTime"
                                    :monthlyWeight="this.monthlyWeight"></month-sales-column>
              </dv-border-box-11>
            </el-col>
          </el-row>
          <!-- 右下 -->
          <el-row>
            <el-col :span="24">
              <dv-border-box-13 class="right-style-center"
                                backgroundColor="#101A34">
                <PieChart v-if="soldRerDay.length"
                          :soldRerDay="this.soldRerDay"></PieChart>
              </dv-border-box-13>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<!-- BaseColumn VerBar DoubleColumnChart BrokenLine -->
<script>
import { mapGetters } from 'vuex'
import ECharts from './components/ECharts'
import RingChart from './components/RingChart' //1
import TransverseColumn from './components/TransverseColumn' //1
import PieChart from './components/PieChart' //1
import LineChart from './components/LineChart' //1
import MonthSalesColumn from './components/MonthSalesColumn' //1
import ShipmentsComparison from './components/ShipmentsComparison' //1
import { dateFormat } from '@/util/date'

// 汇总数据 getSummaryShipment, 日销量车数 getDayTrend, 月度销量 一至当前月 getYearShipment,周销量 getWeekShipment,日销量分物资 getDayShipment , 月度总销量分物资 getMonthShipment， 实时出厂getRealTimeShipment

import {
  getSummaryShipment,
  getDayTrend,
  getYearShipment,
  getWeekShipment,
  getDayShipment,
  getMonthShipment,
  getRealTimeShipment,
} from '@/api/dataDisplay/dataDisplay'

export default {
  name: 'wel',
  components: {
    ECharts,
    RingChart, // 圆环图
    TransverseColumn, // 横向柱状图
    PieChart, // 饼图
    LineChart, // 折线图
    MonthSalesColumn, // 月度销量柱状图
    ShipmentsComparison,
  },

  data() {
    return {
      intervalId: null,
      refreshData: null,
      intervalId2: null,
      fromTotal: {
        daydata: {},
        money: {},
        yeardata: {},
      },
      nowTime: '',
      stockTitle: '销售调拨单执行情况',
      dayTitle: '盘煤日发运量、车数',
      points: [],
      varData: [], // 左上   物资
      weightData: [], // 左上   净重
      dailyCoal: [], // 左中   物资
      dailyWeight: [], // 左中   净重
      weekTime: [], // 左下   日期
      weekWeight: [], // 左下   净重
      monthlyTime: [], // 中下  月份
      monthlyWeight: [], // 中下  净重
      implement: {
        // 右上
        totalAllocation: '', // 调拨总量
        shippingVolume: '', // 发运量
      },
      soldRerDay: [], // 右中  日销量车数
      varietyCoal: [], //  右下   物资
      numberCars: [], // 右下    车数
      netWeight: [], // 右下    净重
      theData: [],
    }
  },
  created() {
    this.getTime()
    this.getThreeMinutes()
    this.getHour()
    this.intervalId = setInterval(this.getsetIntervalData, 180000) // 设置初始定时器
    this.intervalId2 = setInterval(this.getsetIntervalData2, 1800000) // 设置初始定时器
  },
  mounted() {},
  computed: {
    ...mapGetters(['userInfo']),
  },
  methods: {
    getsetIntervalData() {
      console.log(new Date())
      this.getThreeMinutes()
      clearInterval(this.intervalId) // 清除之前的定时器
      this.intervalId = setInterval(this.getsetIntervalData, 180000) // 设置新的定时器
    },
    getsetIntervalData2() {
      console.log(new Date())
      this.getHour()
      clearInterval(this.intervalId2) // 清除之前的定时器
      this.intervalId2 = setInterval(this.getsetIntervalData2, 1800000) // 设置新的定时器
      // 180000
    },
    getThreeMinutes() {
      getDayTrend().then(({ data }) => {
        // console.log(data, '日销量车数')
        this.soldRerDay = []
        data.map((item) => {
          let obj = {
            name: item.varNoName,
            value: item.netWeight,
          }
          this.soldRerDay.push(obj)
        })
      })
      getYearShipment().then(({ data }) => {
        // console.log(data, '月销量')
        this.monthlyTime = []
        this.monthlyWeight = []
        data.forEach((res) => {
          this.monthlyTime.push(res.grossTime) // 月份
          this.monthlyWeight.push(res.netWeight) // 净重
        })
      })
      // 周销量
      getWeekShipment().then(({ data }) => {
        // console.log(data, '周销量')
        this.weekTime = []
        this.weekWeight = []
        data &&
          data.forEach((res) => {
            this.weekTime.push(res.grossTime) // 日期
            this.weekWeight.push(res.netWeight) // 净重
          })
      })
      // 日销量分物资
      getDayShipment().then(({ data }) => {
        // console.log(data, '日销量分物资')
        this.theData = []
        data.map((item) => {
          let obj = {
            name: item.varNoName,
            value: item.netWeight,
          }
          this.theData.push(obj)
        })
      })
      getMonthShipment().then(({ data }) => {
        // console.log(data, '月度总销量分物资')
        this.varData = []
        this.weightData = []
        data.forEach((res) => {
          this.varData.push(res.varNoName)
          this.weightData.push(res.netWeight)
        })
      })
      getRealTimeShipment().then(({ data }) => {
        // console.log(data, '实时出厂', data.length)
        const itemListAll = []
        data.forEach((item) => {
          const itemList = []
          itemList.push(
            item.deptName,
            item.vehicleNo,
            item.varNoName,
            item.money,
            item.tareWeight,
            item.grossTime
          )
          itemListAll.push(itemList)
        })
        this.shipmentsLsit = itemListAll
      })
    },

    // 隔半小时
    getHour() {
      getSummaryShipment().then(({ data }) => {
        // console.log(data, '汇总')
        if (data.length) {
          for (const key in data[0]) {
            if (data[0][key]) {
              this.$set(this.fromTotal, key, '')
              const itemValue = JSON.parse(data[0][key]) || []
              this.$set(
                this.fromTotal,
                key,
                itemValue.length ? itemValue[0] : {}
              )
            }
          }
        }
      })
    },
    getTime() {
      setInterval(() => {
        this.nowTime = dateFormat(new Date())
      }, 1000)
    },
  },
}
</script>

<style lang="scss" scoped>
.therow {
  background: url('img/bg6.png') no-repeat;
  background-size: cover;
  overflow: hidden;
  height: 100vh;
  overflow-y: scroll;
}

// 顶部标题样式
.top_box {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;

  .top_decoration10 {
    position: relative;
    width: 33.3%;
    height: 25px;
  }

  .top_decoration10_reverse {
    transform: rotateY(180deg);
  }

  .title-box {
    display: flex;
    justify-content: center;

    .top_decoration8 {
      width: 250px;
      height: 60px;
      margin-top: 15px;
    }

    .title {
      position: relative;
      width: 560px;
      text-align: center;
      background-size: cover;
      background-repeat: no-repeat;

      .title-text {
        font-size: 28px;
        position: absolute;
        bottom: 0;
        left: 50%;
        color: white;
        font-weight: 400;
        letter-spacing: 10px;
        transform: translate(-50%);
      }

      .top_decoration6 {
        width: 300px;
        height: 10px;
      }

      .title-bototm {
        position: absolute;
        bottom: -20px;
        left: 50%;
        transform: translate(-50%);
      }
    }
  }

  .time-box {
    position: absolute;
    right: 35px;
    top: 40px;
    text-align: right;
    color: #fff;

    h3 {
      font-size: 20px;
      color: #fff;
    }
  }
}

// 左侧样式
.left-style {
  height: auto;
  margin-top: 33px;

  .left-style-top {
    margin-bottom: 10px;
    height: 650px;
    width: 100%;
    border: none;
    font-weight: bolder;
  }

  .left-style-center {
    margin-top: 20px;
    margin-bottom: 10px;
    height: 625px;
    width: 100%;
    border: none;
    font-weight: bolder;
    color: black;
  }

  .left-style-bottom {
    height: 385px;
    padding-top: 60px;
    margin-top: 20px;
    margin-bottom: 30px;
    width: 100%;
    font-weight: bolder;
    color: black;
  }
}

// 中部样式
.center-style {
  .center-style-top {
    height: 830px;
    width: 100%;
    font-weight: bolder;
    color: black;
  }
  .center-top-content {
    width: 100%;
    overflow: hidden;
    height: 780px;
    top: 2%;
    z-index: 9999;

    .total {
      background-color: #10152b;
      height: 380px;
      padding-top: 10px;
      .grid-content {
        text-align: center;
        height: 45px;
        line-height: 45px;
        font-size: 20px;
        color: #637a9c;
      }
      .total-top {
        padding-left: 20px;
        height: 50px;
        line-height: 50px;
        color: #5c8fb3;
        font-size: 25px;
        .total-number {
          display: inline-block;
          width: 35%;
          margin-left: 20px;
          text-align: center;
          color: #f9ee75;
          font-size: 28px;
          font-weight: 800;
          background-color: #0f396b;
        }
      }
      .total-bottom {
        height: 270px;
        margin-top: 20px;
      }
    }

    .collect {
      height: 400px;
      .center-style-collect {
        height: 390px;
      }
    }
  }

  .center-style-bottom {
    margin-top: 40px;
    padding-top: 60px;
    height: 380px;
    width: 100%;
    border: none;
    font-weight: bolder;
    color: black;
  }
}

// 右侧样式
.right-style {
  .right-style-top {
    height: 650px;
    width: 100%;
    font-weight: bolder;
    color: black;
  }

  .div-style {
    position: absolute;
    left: 7%;
    top: 11%;
    width: 100%;
    height: 230px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .style-top {
      width: 90%;
      height: 40px;

      .style-top-dvborder {
        width: 95%;
        height: 100%;
        overflow: hidden;
        margin-top: 20px;

        .style-top-bvborder-div {
          display: flex;
          flex-direction: row;
          width: 100%;
          height: 100%;
        }
      }
    }

    .style-bottom {
      width: 85%;
      height: 130px;
      margin-top: 40px;
      display: flex;

      .style-bottom-top {
        width: 47%;
        height: 100%;
        margin-left: 2%;
        display: flex;
        flex-direction: column;

        .style-bottm-div {
          font-size: 24px;
          text-align: center;
          font-weight: bolder;
          color: #f8f8c0;
          margin-top: 5%;
        }
      }

      .style-bottom-bot {
        width: 47%;
        height: 100%;
        margin-left: 2%;
        display: flex;
        flex-direction: column;

        .style-bottom-bot-div {
          font-size: 24px;
          text-align: center;
          font-weight: bolder;
          color: #f8f8c0;
          margin-top: 5%;
        }
      }
    }

    .div-style-left {
      font-size: 18px;
      text-align: center;
      width: 50%;
      height: 100%;
      border-right: silver 1px solid;
      line-height: 40px;
      font-weight: bolder;
      color: #f8f8c0;
    }

    .div-style-right {
      font-size: 18px;
      text-align: center;
      width: 50%;
      height: 100%;
      line-height: 40px;
      font-weight: bolder;
      color: #f8f8c0;
    }
  }

  .right-style-center {
    margin-top: 30px;
    height: 625px;
    width: 100%;
    border: none;
    font-weight: bolder;
    color: black;
  }

  .right-style-bottom {
    margin-top: 40px;
    height: 440px;
    width: 100%;
    font-weight: bolder;
  }
}

.el-font-size {
  font-size: 14px;
}
</style>
